module.exports = __webpack_public_path__ + "static/img/Section2.f40cc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Section2.png
// module id = IpSH
// module chunks = 1